/**
 * Inline labelled search input — same chrome as <FilterSelect layout="inline" />
 * so the two read as siblings inside a <FilterBar />.
 *
 * Pulled out of constructions, admin.users, admin.reports — they all had
 * the same eyebrow + type="search" + ink-200 border pattern with only
 * the placeholder and width differing.
 */

type SearchInputProps = {
  label?: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  /** Tailwind width class. Default `w-56`. */
  widthClass?: string;
};

export function SearchInput({
  label = "Search",
  value,
  onChange,
  placeholder,
  widthClass = "w-56",
}: SearchInputProps) {
  return (
    <label className="text-sm flex items-center gap-2">
      <span className="eyebrow">{label}</span>
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`border border-ink-200 px-2 py-1 text-sm bg-paper hover:border-ink-400 focus:border-ink-700 focus:outline-none transition-colors ${widthClass}`}
      />
    </label>
  );
}
